export default build =>
    build.mutation({
        query(payload) {         
            return {
                url: '/exam/updateAgent',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['allAgents']       
    })
